import { forwardRef, type SVGProps } from 'react';

export const EmailPlusIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function EmailPlusIcon(props, ref) {
    return (
      <svg
        ref={ref}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          clipRule="evenodd"
          d="M2.588 19.413C2.97933 19.8043 3.45 20 4 20H12.3414C12.1203 19.3744 12 18.7013 12 18H4V8L12 13L20 8V12.3414C20.7452 12.6048 21.4229 13.0113 22 13.5278V6C22.0007 5.45067 21.805 4.98 21.413 4.588C21.021 4.196 20.55 4 20 4H4C3.45067 4.00067 2.98 4.19667 2.588 4.588C2.196 4.97933 2 5.45 2 6V18C2.00067 18.5507 2.19667 19.0217 2.588 19.413ZM20 6L12 11L4 6H20Z"
          fill="#2453B2"
          fillRule="evenodd"
        />
        <path
          d="M17.4286 22V18.5714H14V17.4286H17.4286V14H18.5714V17.4286H22V18.5714H18.5714V22H17.4286Z"
          fill="#2453B2"
        />
      </svg>
    );
  },
);
